import { isFreeSearcher, PERMISSION_NAME } from 'v2/utils/permissions';
import { useFeatureFlags } from 'v2/hooks/useFeatureFlags';
import { FEATURE_FLAGS } from 'utils/constants';
import { Permission, RootState } from 'v2/models';
import { useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { toast } from 'react-toastify';

export const useFreeUser = (): [boolean, Permission | undefined] => {
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );
  const isFreeUser = isFreeSearcher(permissions);
  const [isFreeConnectEnabled] = useFeatureFlags([FEATURE_FLAGS.FREE_CONNECT]);
  const freeSearcherPermission =
    permissions[PERMISSION_NAME.CREATE_SEARCH_FREE];
  return [isFreeUser && isFreeConnectEnabled, freeSearcherPermission];
};

export const useArchiveFreeSearchMutation = (searchId: number) => {
  return useMutation(
    async () => {
      return await restFactory.post(
        `/dj/api/v1/search/${searchId}/archive_free_search/`,
        {}
      );
    },
    {
      onSuccess: () => {
        toast.success('Search archived successfully.');
      },
      onError: () => {
        toast.error('Failed to archive search.');
      },
    }
  );
};
